<cs-icon-button
  class="btn-close"
  iconType="icon"
  icon="fi-x"
  color="secondary"
  size="12"
  (buttonClick)="close()"
></cs-icon-button>

<div class="wrapper">
  <div class="heading">{{ 'timeout' | translate }}</div>
  <div class="cont">
    @if (state === 'timeout') {
      <!-- Timeout 状态 -->
      <div class="description">
        {{ 'your_account_is_on_a_timeout_for_days' | translate: this.data.period }}
      </div>
      <div class="time-wrap">
        <div class="time-info">
          <div class="time-row">
            <span class="time-label">{{ 'start_time' | translate }}</span>
            <span class="time-value">{{ startTime | mdate: 'DD/MM/YYYY, HH:mm' }}</span>
          </div>
          <div class="time-row">
            <span class="time-label">{{ 'end_time' | translate }}</span>
            <span class="time-value">{{ endTime | mdate: 'DD/MM/YYYY, HH:mm' }}</span>
          </div>
        </div>

        <app-countdown-limit [until]="endTime / 1000" (countdownComplete)="onCountdownComplete()"></app-countdown-limit>
      </div>

      <div class="reopen-section">
        @if (!isTimeoutComplete) {
          <span class="reopen-text">
            {{ 'want_to_reopen_early_cooling_off_period' | translate }}
          </span>
        }
        <cs-button
          [label]="isTimeoutComplete ? ('continue_to_login' | translate) : ('reopen_account' | translate)"
          size="large"
          color="primary"
          [loading]="isLoading"
          (buttonClick)="onReopenAccount()"
        ></cs-button>
      </div>

      <span class="contact-text">
        {{ 'increase_timeout_or_make_permanent_contact_support_via' | translate }}
        <span class="chat-link" (click)="toService()">{{ 'live_chat' | translate }}</span>
      </span>
    } @else {
      <!-- Reopen 状态 -->
      <div class="description">
        {{ 'your_account_is_in_a_cooling_off_period_access_in' | translate }}
      </div>

      <app-countdown-limit
        [until]="endTime / 1000"
        [showDays]="false"
        (countdownComplete)="onCountdownComplete()"
      ></app-countdown-limit>
      @if (isReopenComplete) {
        <cs-button
          [label]="'continue_to_login' | translate"
          size="large"
          color="primary"
          (buttonClick)="onReopenAccount()"
        ></cs-button>
      }
      <span class="contact-text">
        {{ 'increase_timeout_or_make_permanent_contact_support_via' | translate }}
        <span class="chat-link" (click)="toService()">{{ 'live_chat' | translate }}</span>
      </span>
    }
  </div>
</div>
